/* eslint-disable max-classes-per-file */
import { IEvent } from "../../../common/services/cqs/event.service";
import { IHitItem, IMapComponent, IMapMouse } from "./map.models";
import { IMapGeometry } from "./map.settings";
import { IMapQueryResult } from "./services/map-query.service";

export class MapSelectedEvent implements IEvent {
    $type: string;
    selected: IMapGeometry[];
    layerid: string;

    static readonly EVENTNAME = "MapSelectedEvent";

    constructor(selectedGeometries: IMapGeometry[], layer: string) {
        this.$type = `common.components.map.${MapSelectedEvent.EVENTNAME},${MapSelectedEvent.EVENTNAME}`;
        this.selected = selectedGeometries;
        this.layerid = layer;
    }
}

export class MapDeselectedEvent implements IEvent {
    $type: string;
    deselected: IMapGeometry[];
    layerid: string;

    static readonly EVENTNAME = "MapDeselectedEvent";

    constructor(deselectedGeometries: IMapGeometry[], layer: string) {
        this.$type = `common.components.map.${MapDeselectedEvent.EVENTNAME},${MapDeselectedEvent.EVENTNAME}`;
        this.deselected = deselectedGeometries;
        this.layerid = layer;
    }
}

export class MapHoverEvent implements IEvent {
    $type: string;
    geometry: IMapGeometry;
    layerid: string;
    mouse: any;
    isMouseover: boolean;

    static readonly EVENTNAME = "MapHoverEvent";

    constructor(layerid: string, geo: IMapGeometry, mouse, isMouseover = true) {
        this.$type = `common.components.map.${MapHoverEvent.EVENTNAME},${MapHoverEvent.EVENTNAME}`;
        this.geometry = geo;
        this.layerid = layerid;
        this.mouse = mouse;
        this.isMouseover = isMouseover;
    }
}

export class LayerReadyEvent implements IEvent {
    $type: string;
    layerid: string;

    static readonly EVENTNAME = "LayerReadyEvent";
    constructor(layerid: string) {
        this.$type = `common.components.map.${LayerReadyEvent.EVENTNAME},${LayerReadyEvent.EVENTNAME}`;
        this.layerid = layerid;
    }
}

export class MapReadyEvent implements IEvent {
    $type: string;
    map: IMapComponent;

    static readonly EVENTNAME = "MapReadyEvent";
    constructor(map: IMapComponent) {
        this.map = map;
        this.$type = `common.components.map.${MapReadyEvent.EVENTNAME},${MapReadyEvent.EVENTNAME}`;
    }
}

export class AllLayersReadyEvent implements IEvent {
    $type: string;
    id: string;
    layers: any[];

    static readonly EVENTNAME = "AllLayersReadyEvent";
    constructor(id: string, layers: any[]) {
        this.$type = `common.components.map.${AllLayersReadyEvent.EVENTNAME},${AllLayersReadyEvent.EVENTNAME}`;
        this.layers = layers;
        this.id = id;
    }
}

export class MapClickedEvent implements IEvent {
    $type: string;
    point: any;
    coords: any;

    static readonly EVENTNAME = "MapClickedEvent";
    constructor(point: any, coords: any) {
        this.$type = `common.components.map.${MapClickedEvent.EVENTNAME},${MapClickedEvent.EVENTNAME}`;
        this.point = point;
        this.coords = coords;
    }
}

export class MapRightClickedEvent implements IEvent {
    $type: string;

    static readonly EVENTNAME = "MapRightClickedEvent";
    constructor(
        public map: IMapComponent,
        public mouse: IMapMouse,
        public hititems: IHitItem[],
        public queryResult: IMapQueryResult[],
        public isCtrlKey: boolean,
        public count: number,
        public length: number,
        public id: string) {
        this.$type = `common.components.map.${MapRightClickedEvent.EVENTNAME},${MapRightClickedEvent.EVENTNAME}`;
    }
}

export class MapClosingPopupEvent implements IEvent {
    $type: string;
    popup: string;

    static readonly EVENTNAME = "MapClosingPopup";
    constructor(popup: string) {
        this.$type = `common.components.map.${MapClosingPopupEvent.EVENTNAME},${MapClosingPopupEvent.EVENTNAME}`;
        this.popup = popup;
    }
}
